import { useState, useEffect } from "react";
import { getRecentNotifications } from "../services/micro";
import { toast } from "react-toastify";

export function useRecentNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [newNotificationAmount, setNewNotificationAmount] = useState(0);

  useEffect(() => {
    getRecentNotifications()
      .then((res) => {
        if (res?.success) {
          setNewNotificationAmount(res?.data?.new || 0);
          setNotifications(res?.data?.notifications || []);
        } else {
          // toast.error("Failed to fetch recent notifications");
          console.log("Failed to fetch recent notifications", res);
        }
      })
      .catch((e) => {
        console.log(e)
      });
  }, []);

  return { notifications, newNotificationAmount };
}
